'use client';

import { c as _c } from "react/compiler-runtime";
import type { NexperienceFragment } from '@data-access/lib/gql/experience/documents';
import { Backpack } from '@phosphor-icons/react';
import { isAppEnv } from '@utils/utils-config';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { isCountryCode } from 'src/shared/utils/is-country-code';
import { useIntersectionObserver } from 'usehooks-ts';
const COUNTRY_LABELS: Record<string, string> = {
  AT: 'Österreich',
  CH: 'Schweiz',
  DE: 'Deutschland',
  DK: 'Dänemark',
  FR: 'Frankreich',
  IT: 'Italien',
  LU: 'Luxemburg',
  NL: 'Niederlande'
};
const AppExperienceSimpleMap = dynamic(() => import('./app-experience-simple-map').then(m => m.AppExperienceSimpleMap), {
  ssr: false
});
export function AppExperienceMeetingPoint(t0) {
  const $ = _c(30);
  const {
    experience: t1
  } = t0;
  const {
    location
  } = t1;
  const {
    address,
    lat: latitude,
    lng: longitude,
    name: locationName,
    description,
    varying
  } = location;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = isAppEnv("e2e");
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const skipLiveMap = t2;
  const [mapMounted, setMapMounted] = useState(false);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      rootMargin: "100px",
      freezeOnceVisible: true,
      onChange: isIntersecting => {
        if (isIntersecting) {
          setMapMounted(true);
        }
      }
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const {
    ref
  } = useIntersectionObserver(t3);
  let meetingPointData;
  let t4;
  if ($[2] !== address || $[3] !== locationName) {
    meetingPointData = [locationName, ...address.split(", ")].filter(Boolean);
    const country = meetingPointData.at(-1);
    t4 = isCountryCode(country) ? COUNTRY_LABELS[country] ?? country : country;
    $[2] = address;
    $[3] = locationName;
    $[4] = meetingPointData;
    $[5] = t4;
  } else {
    meetingPointData = $[4];
    t4 = $[5];
  }
  const mappedCountry = t4;
  let t5;
  if ($[6] !== meetingPointData) {
    t5 = meetingPointData.slice(0, -1);
    $[6] = meetingPointData;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== mappedCountry || $[9] !== t5) {
    t6 = [...t5, mappedCountry];
    $[8] = mappedCountry;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const mappedMeetingPointData = t6;
  let t7;
  if ($[11] !== latitude || $[12] !== longitude || $[13] !== mapMounted || $[14] !== ref) {
    t7 = Boolean(latitude) && Boolean(longitude) && <div ref={ref} className="my-6 aspect-video overflow-hidden rounded-xl sm:my-8">{mapMounted && !skipLiveMap ? <AppExperienceSimpleMap latitude={latitude} longitude={longitude} /> : <div className="size-full bg-sand" />}</div>;
    $[11] = latitude;
    $[12] = longitude;
    $[13] = mapMounted;
    $[14] = ref;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Backpack className="absolute -top-2 left-0 size-10 -translate-x-1/2 rounded-full border-8 border-white bg-primary p-1 text-white sm:size-12" />;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== mappedMeetingPointData) {
    t9 = <address className="flex flex-col">{mappedMeetingPointData.map(_temp)}</address>;
    $[17] = mappedMeetingPointData;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== description) {
    t10 = description && <span className="mt-4">{description}</span>;
    $[19] = description;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== varying) {
    t11 = varying && <span className="mt-4">Der Treffpunkt kann abweichen und wird kurz vor dem Erlebnis bekannt gegeben.</span>;
    $[21] = varying;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t9) {
    t12 = <ol className="ml-4"><li className="relative">{t8}<div className="flex flex-col pl-6 sm:pl-8">{t9}{t10}{t11}</div></li></ol>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t7) {
    t13 = <>{t7}{t12}</>;
    $[27] = t12;
    $[28] = t7;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
}
function _temp(item, idx) {
  return <span key={idx}>{item}</span>;
}